export const setUserPrivileges = (UserPrivileges) => {
  return {
    type: "SET_UserPrivileges",
    UserPrivileges,
  };
};